import React from 'react'
import {useSelector} from 'react-redux'
import {selectProposalCountry} from '../../../../app-store/ProposalSlice'
// import {PTStarSVG} from '../../../../assets'
import {
  CardTop,
  CenterGroup,
  SelectionIndicator,
  // OptionLabel,
  OptionNameRow,
  OptionName,
  // StarsWrap,
  DueTodayLabel,
  PriceRow,
  TotalPrice,
  MonthlyText,
} from './styled.components'

const COUNTRY_LOCALE = {
  US: {locale: 'en-US', currency: 'USD'},
  AU: {locale: 'en-AU', currency: 'AUD'},
  CA: {locale: 'en-CA', currency: 'CAD'},
  NZ: {locale: 'en-NZ', currency: 'NZD'},
  GB: {locale: 'en-GB', currency: 'GBP'},
}

function formatCurrency(amount, country) {
  const n = Number(amount) || 0
  const {locale, currency} = COUNTRY_LOCALE[country] ?? COUNTRY_LOCALE.US
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n)
}

// function StarRating({count, total}) {
//   return (
//     <StarsWrap>
//       {Array.from({length: total}, (_, i) => i + 1).map(n => (
//         <PTStarSVG
//           key={n}
//           width="18"
//           height="18"
//           style={n > count ? {filter: 'grayscale(1)', opacity: 0.7} : {}}
//         />
//       ))}
//     </StarsWrap>
//   )
// }

function ProposalCardTop({
  idx,
  optionName,
  starCount,
  totalStars = 3,
  dueTodayTotal,
  monthlyTotal,
  selectable = false,
  selected = false,
  onSelect,
  actionBtn,
  align,
}) {
  const country = useSelector(selectProposalCountry) ?? 'US'

  const pricing = (
    <>
      <DueTodayLabel>Due Today</DueTodayLabel>
      <PriceRow>
        <TotalPrice>{formatCurrency(dueTodayTotal, country)}</TotalPrice>
        {/* FULSAS-14570: an option with a charge today but nothing billed
            monthly (e.g. an annual plan) shows "then $0.00/mo"; a completely
            empty option still shows nothing. */}
        {(Number(monthlyTotal) > 0 || Number(dueTodayTotal) > 0) && (
          <MonthlyText>
            then <strong>{formatCurrency(monthlyTotal, country)}</strong>/mo
          </MonthlyText>
        )}
      </PriceRow>
    </>
  )

  if (selectable) {
    return (
      <CardTop selectable selected={selected} onClick={onSelect} role="button">
        <SelectionIndicator
          selected={selected}
          tabIndex={-1}
          aria-hidden="true"
        >
          {selected && '✓'}
        </SelectionIndicator>
        <CenterGroup align={align}>
          <OptionName>{optionName}</OptionName>
        </CenterGroup>
        {pricing}
      </CardTop>
    )
  }

  return (
    <CardTop>
      <OptionNameRow>
        <OptionName>{optionName}</OptionName>
        {actionBtn && (
          <div style={{marginLeft: 'auto', flexShrink: 0, paddingLeft: 8}}>
            {actionBtn}
          </div>
        )}
      </OptionNameRow>
      {pricing}
    </CardTop>
  )
}

export {ProposalCardTop}
